module.exports = __webpack_public_path__ + "static/media/img_21.3c5ac467.png";